import { render, staticRenderFns } from "./ChangeStatusItem.vue?vue&type=template&id=f158da36&"
import script from "./ChangeStatusItem.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports